export default "__VITE_ASSET__IqcnO46$__"